/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-magic-numbers */
// 注册
import React, { useEffect, useState, useRef } from 'react'
import styles from './register.module.scss'
import { useNavigate, useSearchParams } from 'react-router-dom'
import activityApi from '@/apis/activity'
import indexApi, { FomrSubmitStatusParams } from '@/apis'
import fingerprintjs from '@fingerprintjs/fingerprintjs'
import Skin5 from './components/skin5/skin5'
import Skin6 from './components/skin6/skin6'
import Skin7 from './components/skin7/skin7'
import Skin360 from './components/skin-360/skin-360'
import Skin8 from './components/skin8/skin8'
import Skin9 from './components/skin9/skin9'
import Skin10 from './components/skin10/skin10'
import Skin11 from './components/skin11/skin11'
import Skin12 from './components/skin12/skin12'
import Skin13 from './components/skin13/skin13'
import Skin14 from './components/skin14/skin14.'
import Skin15 from './components/skin15/skin15'
import { Storage, formatTime } from '@bihu/common-js'
import { CURRENT_SKIN_INDEX, TOKEN } from '@/constants/storage'
import useFirstOrAfter from '@/hooks/use-first-or-after'
// import DetainmentPopup from './components/detainment-popup/detainment-popup'
import LoginPopup from './components/login-popup/login-popup'
import { useSelector } from 'react-redux'
import { RootState } from '@/store'
import { FqlPhoneModel } from '@/constants/common'
import {
  RegisterSkinContainer,
  resolveRegisterPresentation,
} from '@/pages/application-flow-skins'
import useV2RegisterBusinessBridge from './hooks/use-v2-register-business-bridge'
interface Props {
  type?: 'getQuota', // 领取额度
}

const adChannelType = {
  register: 1,
  getQuota: 2
}

const Register: React.FC<Props> = props => {

  const { channelValue, adChannelCode } = useSelector((state: RootState) => state.channel)
  const navigate = useNavigate()
  const { type } = props
  // 当前皮肤号
  const [currentSkinIndex, setCurrentSkinIndex] = useState<number>(3)

  // 是否显示弹窗
  const [isShowPopup, setIsShowPopup] = useState<boolean>(false)
  const [isSkin6, setIsSkin6] = useState<boolean>(false)
  const [isSkin7, setIsSkin7] = useState<boolean>(false)
  const [isSkin8, setIsSkin8] = useState<boolean>(false)
  const [isSkin9, setIsSkin9] = useState<boolean>(false)
  const [isSkin10, setIsSkin10] = useState<boolean>(false)
  const [isSkin11, setIsSkin11] = useState<boolean>(false)
  const [isSkin12, setIsSkin12] = useState<boolean>(false)
  const [isSkin13, setIsSkin13] = useState<boolean>(false)
  const [isSkin14, setIsSkin14] = useState<boolean>(false)
  const [isSkin15, setIsSkin15] = useState<boolean>(false)
  const [isSkin360, setIsSkin360] = useState<boolean>(false)
  const [showSkin5Page, setShowSkin5Page] = useState<boolean>(false)
  const [showPage, setShowPage] = useState<boolean>(false)
  const [codeDetail, setCodeDetail] = useState<any>()
  // 是否直接走h5产品匹配页面
  const [isMatchH5Login, setIsMatchH5Login] = useState(null)
  // 解密后的手机号（仅特定渠道使用）
  const [decryptedMobile, setDecryptedMobile] = useState('')

  // 生成随机数范围
  const randomNum = (minNum: number, maxNum: number) => {
    return parseInt((Math.random() * (maxNum - minNum + 1) + minNum).toString(), 10)
  }

  const originalPushState = window.history.pushState
  // type myPushState = typeof window.history.pushState
  // eslint-disable-next-line no-shadow
  window.history.pushState = function myPushState(...args) {
    // console.log('pushState', args, window.history.state)
    return originalPushState.apply(this, args)
  }

  useFirstOrAfter(() => {
    const skinIndex = Storage.get(CURRENT_SKIN_INDEX)
    // 有缓存的皮肤index，则+1
    if (skinIndex) {
      let temp = skinIndex + 1
      if (temp > 4) {
        temp = 1
      }

      setCurrentSkinIndex(temp)
      Storage.set(CURRENT_SKIN_INDEX, temp)
    } else { // 没有缓存皮肤index, 则随机
      let tempRandomNum = randomNum(1, 4)
      setCurrentSkinIndex(tempRandomNum)
      Storage.set(CURRENT_SKIN_INDEX, tempRandomNum)
    }
    localStorage.removeItem('productBack')
    // 判断是否分期乐渠道
    if (channelValue?.includes('fenqile')) {
      if (!Storage.get('isRefreshLoadPage') && !search.get('refresh')) {
        Storage.set('isRefreshLoadPage', true)
        window.location.href = `${document.URL}&refresh=1`
        return
      } else {
        Storage.set('isRefreshLoadPage', false)
      }

      // 监听浏览器回退事件
      window.addEventListener('popstate', back, false)
      // window.onpopstate = back
      window.history.pushState(null, 'null', document.URL)

      return () => {
        // 回退事件只用于当前组件，则需要在组件销毁时把回退事件销毁
        window.removeEventListener('popstate', back, false)
        // window.onpopstate = null
      }
    }
  }, () => {
    // eslint-disable-next-line no-console
    console.log('afterFn')
  }, [])

  // 返回
  const back = () => {
    const productBack = localStorage.getItem('productBack')
    const isShowPopupStorage = Storage.get('isShowPopup')

    try {
      if (isShowPopupStorage) {
        Storage.set('isShowPopup', false)
        setIsShowPopup(false)
        navigate(-1)

      } else {
        //  阻止浏览器回退事件
        setIsShowPopup(true)
        Storage.set('isRefreshLoadPage', false)
        // window.history.pushState(null, 'null', document.URL)
        // localStorage.setItem('productBack', formatTime(Date.now(), 'YYYY-MM-DD'))
        Storage.set('isShowPopup', true)
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      // console.log(error)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }

  const [search] = useSearchParams()

  // 渠道编码
  // const [adChannelCode, setAdChannelCode] = useState('')

  const judgeLoginAfterPage = () => {
    // 如果是注册匹配h5产品流程，则直接跳转h5产品匹配动画页面
    if (isMatchH5Login) {
      window.location.href = `/fill-information/match-h5-animation?adChannelCode=${adChannelCode}&h5MatchRealization=${isMatchH5Login}`
      return
    }
    if (channelValue?.includes('fenqile')) {
      window.location.href = `/new-fill-information?adChannelCode=${adChannelCode}` //如果访问链接是getQuota类型，就跳转表单填写页
      return
    }
    if (type === 'getQuota' && adChannelCode !== 'YxNj9v') {
      window.location.href = `/fill-information?adChannelCode=${adChannelCode}` //如果访问链接是getQuota类型，就跳转表单填写页
    } else {
      window.location.href = `/fill-information/success?options=${encodeURIComponent(JSON.stringify({ isNotFormReq: true }))}`
    }
  }

  // 有token状态下，判断下一页的跳转
  const judgeNextPage = async() => {
    // 判断是否是快手渠道
    let ksCallBack = localStorage.getItem('ksCallBack') || search.get('ksCallBack')
    if (channelValue?.includes('ksBurying') && ksCallBack) {
      await indexApi.ksCallbackRelation(ksCallBack)
      localStorage.removeItem('ksCallBack')
    }
    // 如果是注册-下载模式，直接跳转下载页
    if (codeDetail.linkType === adChannelType.register) {
      window.location.href = `/fill-information/success?options=${encodeURIComponent(JSON.stringify({
        isNotFormReq: true,
        isSpecialListCity: true
      }))}`
      return
    }
    // 获取表单填写状态  submitStatus >>> 0:未提交 1:已提交未授权 10:已授权
    const res: any = await indexApi.getApplyStatus()
    if (res.code === 200) {
      // 判断是否华为手机(针对个别渠道会用到，如分期乐)
      let isHuaWeiPhone = false
      const userAgent = navigator.userAgent.toLowerCase()
      if (userAgent.indexOf('huawei') !== -1) {
        isHuaWeiPhone = true
      }
      if (res.data && res.data?.submitStatus === 1) {
        let submitData: FomrSubmitStatusParams = {
          adChannelCode
        }
        const phoneModel = sessionStorage.getItem('phoneModel')
        if (phoneModel) {
          submitData.phoneModel = phoneModel as FqlPhoneModel
        }
        // 获取上回提交信息
        const submitResult: any = await indexApi.getFomrSubmitStatus(submitData)
        if (submitResult.productName === null) {
          window.location.replace(`/fill-information/success?options=${encodeURIComponent(JSON.stringify({
            isNotFormReq: true,
            rePageShowType: channelValue?.includes('fenqile') && isHuaWeiPhone ? 2 : 0,
            revisit: true
          }))}`)
          return
        }

        if (submitResult.thirdpartyType === 5) {
          window.location.replace(`/fill-information/authorize?options=${encodeURIComponent(JSON.stringify(submitResult))}&adChannelCode=${adChannelCode}&isHuaWeiPhone=${isHuaWeiPhone}&applyLimit=${res.data.applyLimit}`)
        }
        // 跳转授权页
        let tempOptions = {
          adChannelCode,
          isHuaWeiPhone,
          applyLimit: res.data.applyLimit,
          workCity: res.data.workCity,
          rqResult: submitResult
        }
        if (channelValue?.includes('fenqile')) {
          window.location.replace(`/new-fill-information?options=${encodeURIComponent(JSON.stringify(tempOptions))}&applyLimit=${res.data.applyLimit}&isHuaWeiPhone=${isHuaWeiPhone}&adChannelCode=${adChannelCode}`)
        } else {
          window.location.replace(`/fill-information/common-authorize?options=${encodeURIComponent(JSON.stringify(tempOptions))}&applyLimit=${res.data.applyLimit}&isHuaWeiPhone=${isHuaWeiPhone}`)
        }
        //
      } else if (res.data && res.data?.submitStatus === 10) {
        let submitData: FomrSubmitStatusParams = {
          adChannelCode
        }
        const phoneModel = sessionStorage.getItem('phoneModel')
        if (phoneModel) {
          submitData.phoneModel = phoneModel as FqlPhoneModel
        }
        // rematchResult: 1-不需要重新匹配 2-重新匹配不到结果 3-重新匹配到结果
        const reMatchResult: any = await indexApi.getFomrSubmitStatus(submitData)
        let tempOptions: any = {}
        // 如果重现匹配并且有结果，跳至动图页
        if (reMatchResult.rematchResult === 3) {
          // 携带授权数据跳转重新匹配结果页
          tempOptions = {
            adChannelCode,
            isHuaWeiPhone,
            applyLimit: res.data.applyLimit,
            workCity: res.data.workCity,
            rqResult: reMatchResult
          }
          console.log(tempOptions)
          // eslint-disable-next-line max-depth
          window.location.replace(`/fill-information/rematch-waiting?options=${encodeURIComponent(JSON.stringify(tempOptions))}`)
          return
        }
        // 否则取上回的结果，跳至下载页
        tempOptions = JSON.parse(JSON.stringify(reMatchResult))
        tempOptions.isNotFormReq = true // 标记为非表单请求方式的跳转
        tempOptions.rePageShowType = channelValue?.includes('fenqile') && isHuaWeiPhone ? 2 : 0
        tempOptions.revisit = true // 标记为再访
        window.location.replace(`/fill-information/success?options=${encodeURIComponent(JSON.stringify(tempOptions))}`)
      } else {
        // 来到这说明未提交表单
        judgeLoginAfterPage()
      }
    } else {
      setShowPage(true)
    }
  }

  // 根据当地时间判断 9:00-19:00
  const isDay = () => {
    const hours = new Date().getHours()
    console.log(hours)

    return hours >= 9 && hours < 18
  }

  const getUserLocation = async(code: string, city: string[], path: string, day?: boolean) => {
    try {
      let res = await activityApi.reverseGeoNoAuth({ adChannelCode: code })
      if (!city.includes(res.data.city)) {
        // if (day && isDay()) {
        //   return false
        // }
        const fp = await fingerprintjs.load()
        const { visitorId } = await fp.get()
        await activityApi.reportAdChannelClick({
          adChannelCode: code,
          fingerprint: visitorId,
          abTestType: 15
        })
        window.location.href = path
        return true
      }

      return false
    } catch (err) {
      return false
    }
  }

  /**
   * 根据后端动态配置判断是否触发切流重定向
   * 注意：excludeCityList，用户不在城市列表中时才触发跳转，否则留在自己的表单页面
   * @param {string} code 渠道代码
   * @returns {Promise<boolean>} 是否触发重定向
   */
  const checkChannelDirect = async(code: string): Promise<boolean> => {
    // 仅允许指定渠道进行切流校验，减少服务器访问压力
    const allowChannels = ['34zGCo', 'j3Adjk', 'vO4jF9', 'YpvLEj', 'YWzS9q']
    if (!allowChannels.includes(code)) {
      return false
    }

    try {
      // 获取当前渠道的切流配置
      const directRes: any = await activityApi.getChannelDirectUrl(code)
      const { productUrl, excludeCityList } = directRes?.data || {}

      // 未配置则直接放行
      if (!productUrl || !excludeCityList?.length) {
        return false
      }

      // 获取用户 IP 所在城市
      const geoRes: any = await activityApi.reverseGeoNoAuth({ adChannelCode: code })
      const userCity = geoRes?.data?.city

      // 用户城市不在白名单中 → 触发切流跳转
      if (userCity && !excludeCityList.includes(userCity)) {
        // 上报埋点（fire-and-forget，不阻塞跳转）
        fingerprintjs.load()
          .then(fp => fp.get())
          .then(({ visitorId }) => {
            activityApi.reportAdChannelClick({
              adChannelCode: code,
              fingerprint: visitorId,
              abTestType: 15
            })
          })

        window.location.href = productUrl
        return true
      }

      return false
    } catch (err) {
      // 接口异常或网络错误，静默放行，不影响正常注册流程
      return false
    }
  }

  const handleMainFlow = async() => {
    // 获取平台来源
    const platFormSource = search.get('platformSource')
    if (platFormSource) {
      sessionStorage.setItem('FLATFORM_SOURCE', platFormSource)
    }

    // 动态切流校验（后端配置驱动，替代原有硬编码判断逻辑）
    if (adChannelCode) {
      const isRedirected = await checkChannelDirect(adChannelCode)
      if (isRedirected) {
        return
      }
    }

    // if (adChannelCode === 'hDFBgw') {
    //   if (await getUserLocation(adChannelCode, ['深圳市'], 'https://gw.xiaoyiqb.cn/customer/channel/channelPage.e?channelId=6073')) {
    //     return
    //   }
    // }
    // if (adChannelCode === 'D7PeH9') {
    //   if (await getUserLocation(adChannelCode, ['上海市'], 'https://gw.xlsltech.com/customer/channel/channelPage.e?channelId=5981')) {
    //     return
    //   }
    // }
    // if (adChannelCode === 'TDJTBm' || adChannelCode === 'OFb2g4') {
    //   if (await getUserLocation(adChannelCode, ['长沙市', '湘潭市'], 'https://lhdz.wantongjr.top/CcjV4IThannel/index.html#/')) {
    //     return
    //   }
    // }
    // if ((adChannelCode === 'vdC4PZ' || adChannelCode === 'Noacf6') && !isDay()) {
    //   if (await getUserLocation(adChannelCode, ['上海市'], 'https://lhdz.wantongjr.top/CcjV4IThannel/index.html#/', true)) {
    //     return
    //   }
    // }
    const hasToken = Storage.get(TOKEN)
    // 判断是否有token(360渠道、拍拍贷渠道对token的判断单独放在各自对应的皮肤组件里)
    // const sepcialChannels = ['hBSfjw', 'ZoJERy', 'rWMspl', 'ZgvvGJ', 'pmeLeA']
    if (hasToken && !codeDetail.location) { // 有token并且不需要获取定位，接着执行下一步
      judgeNextPage()
    } else if (channelValue?.includes('hbjf')) {
      setTimeout(() => {
        setShowPage(true)
      }, 2000)
    } else {
      setShowPage(true)
    }

    if (adChannelCode) {
      // 判断如果渠道码是NRxJgP，则使用皮肤6
      if (adChannelCode === 'NRxJgP') {
        setIsSkin6(true)
      }
      // 判断如果渠道码是hBSfjw，则使用360皮肤
      if (adChannelCode === 'hBSfjw') {
        setIsSkin360(true)
      }
      // 判断如果渠道码是FnbhpG，则使用皮肤9(借呗)
      if (adChannelCode === 'FnbhpG') {
        setIsSkin9(true)
      }
      // 判断如果是借掌柜渠道，使用皮肤9
      if (channelValue?.includes('jiezhanggui')) {
        setIsSkin9(true)
      }

      if (channelValue?.includes('huanbei')) {
        setIsSkin8(true)
      }

      // if (channelValue?.includes('kuaishou')) {
      //   setIsSkin10(true)
      // }

      if (channelValue?.includes('mjy')) {
        setIsSkin11(true)
      }

      // 判断是如果是聚富渠道，则使用皮肤12
      if (channelValue?.includes('jufu')) {
        // changeIcoFavicons('jufu-favicon.ico')
        setIsSkin12(true)
      }
      // 如果是腾讯渠道，则使用皮肤14
      if (channelValue?.includes('tengxun')) {
        setIsSkin14(true)
      }
      // 享呗金服渠道，使用皮肤15
      if (channelValue?.includes('hbjf')) {
        setIsSkin15(true)
      }
      //  百度渠道，使用皮肤13
      if (channelValue?.includes('baidu')) {
        setIsSkin13(true)
      }

      setTimeout(() => {
        setShowSkin5Page(true)
      }, 10)
    }
  }

  const prevChannelValue = useRef<boolean | null>(false)

  useEffect(() => {
    if (currentSkinIndex && adChannelCode && !prevChannelValue.current) {
      prevChannelValue.current = true
      // 获取到浏览器指纹后调用上报接口
      fingerprintjs.load().then(fp => fp.get())
        .then(result => {
          const { visitorId } = result
          activityApi.reportAdChannelClick({
            adChannelCode,
            fingerprint: visitorId,
            abTestType: isSkin6 ? 6 : 5 // 固定皮肤数
            // abTestType: currentSkinIndex // 随机皮肤数
          })
        })
    }
  }, [currentSkinIndex, adChannelCode])

  useEffect(() => {
    let url = window.location.href
    const channelType = new URL(url).pathname.split('/').pop()
    localStorage.setItem('ad_channel_type', channelType || '')
    const getChannelDetail = async() => {
      const codeDetailRes: any = await activityApi.getChannelCodeDetail(adChannelCode)
      //广告渠道状态，1-正常，0-禁用
      if (codeDetailRes && codeDetailRes.channelStatus === 0) {
        window.location.href = '/failure'
        return
      }
      if (codeDetailRes?.h5MatchRealization) {
        setIsMatchH5Login(codeDetailRes.h5MatchRealization)
      }
      setCodeDetail(codeDetailRes)
    }
    if (adChannelCode) {
      getChannelDetail()
    }
  }, [adChannelCode])

  useEffect(() => {
    const decryptUrlParams = async() => {
      const encryptMobile = search.get('encryptMobile')
      if (!encryptMobile) {
        setDecryptedMobile('')
        return
      }
      try {
        const decryptBody: Record<string, string> = {}
        search.forEach((value, key) => {
          // URL query中 '+' 会被解码为空格，这里对加密手机号做还原，避免解密失败
          decryptBody[key] = key === 'encryptMobile' ? value.replace(/ /g, '+') : value
        })
        const decryptRes: any = await activityApi.decryptParams(decryptBody)
        const mobile = decryptRes?.data?.mobile
        if (mobile) {
          setDecryptedMobile(mobile)
        } else {
          setDecryptedMobile('')
        }
      } catch (error) {
        setDecryptedMobile('')
      }
    }
    if (adChannelCode) {
      decryptUrlParams()
    }
  }, [adChannelCode, search])

  // ===== 新皮肤接入 =====
  // 本区块只解析渠道展示配置并注入旧业务 Bridge；接口、Storage、定位与后续分流均保留在旧注册模块。
  const v2Presentation = resolveRegisterPresentation(codeDetail)
  const isV2Register = v2Presentation !== null
  const v2BusinessBridge = useV2RegisterBusinessBridge({
    adChannelCode,
    channelDetail: codeDetail,
    channelValue,
    isV2Register,
    onContinue: judgeNextPage,
    showPage,
    type,
  })

  const renderSkinComponent = () => {
    if (v2Presentation) {
      return (
        <RegisterSkinContainer
          brandName={v2Presentation.brandName}
          isJhjBrand={v2Presentation.isJhjBrand}
          onBack={v2BusinessBridge.handleBack}
          onOpenProtocol={v2BusinessBridge.openProtocol}
          onRequestCode={v2BusinessBridge.requestCode}
          onSubmitRegister={v2BusinessBridge.submitRegister}
          theme={v2Presentation.theme}
        />
      )
    }

    switch (true) {
      case isSkin6:
        return <Skin6 type={type} channelDetail={codeDetail} callBack={() => judgeNextPage()} />
      case isSkin7:
        return <Skin7 type={type} channelDetail={codeDetail} callBack={() => judgeNextPage()} />
      case isSkin360:
        return <Skin360 channelDetail={codeDetail} type={type} callBack={() => judgeNextPage()} />
      case isSkin8:
        return <Skin8 type={type} channelDetail={codeDetail} callBack={() => judgeNextPage()} />
      case isSkin9:
        return <Skin9 type={type} channelDetail={codeDetail} callBack={() => judgeNextPage()} />
      case isSkin10:
        return <Skin10 type={type} channelDetail={codeDetail} callBack={() => judgeNextPage()} />
      case isSkin11:
        return <Skin11 type={type} channelDetail={codeDetail} callBack={() => judgeNextPage()} />
      case isSkin12:
        return <Skin12 type={type} channelDetail={codeDetail} callBack={() => judgeNextPage()} decryptedMobile={decryptedMobile} />
      case isSkin13:
        return <Skin13 type={type} channelDetail={codeDetail} callBack={() => judgeNextPage()} />
      case isSkin14:
        return <Skin14 type={type} channelDetail={codeDetail} callBack={() => judgeNextPage()} />
      case isSkin15:
        return <Skin15 type={type} channelDetail={codeDetail} callBack={() => judgeNextPage()} />
      default:
        return showSkin5Page ? (
          <Skin360 type={type} channelDetail={codeDetail} callBack={() => judgeNextPage()} />
        ) : null
    }
  }

  useEffect(() => {
    if (codeDetail) {
      // 执行页面主流程
      handleMainFlow()
    }
  }, [codeDetail, channelValue])

  return (
    <div className={styles.registerPage}>
      {
        showPage ? <>
          <div>
            {renderSkinComponent()}
            {
              isShowPopup && channelValue?.includes('fenqile') && <LoginPopup type={type} callBack={() => setIsShowPopup(false)} />
            }
          </div>
        </> : <>
          {/* 享呗金服加载动画切换 */}
          {
            channelValue?.includes('hbjf') ? <div className={styles.hengbeiLoading} >
              <div className={styles.loadingBox}>
                <img src={require('@/assets/imgs/gif/loading.gif')} alt="" />
                <span>正在评估您的借款申请...</span>
              </div>
            </div> : <div id="root">
              <div id="loading-box">
                <div className={styles.ballClipRotateMultiple}>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          }

        </>
      }
    </div>
  )
}

export default Register
